import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import FormErrorHandler
  from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/FormErrorHandler';
import './CommonWidgetEditFields.css';
import AltErrorWrapper
  from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/AltErrorWrapper/AltErrorWrapper';

let nextGroupId = 1;

const CommonWidgetEditFields = ({ context, onChange, errors }) => {
  const groupIdRef = useRef(null);
  if (groupIdRef.current == null) {
    groupIdRef.current = `showTitle-${nextGroupId}`;
    nextGroupId += 1;
  }
  const radioName = groupIdRef.current;

  // eslint-disable-next-line react/destructuring-assignment
  const title = context.title || '';
  // eslint-disable-next-line react/destructuring-assignment
  const showTitle = context.showTitle === true;
  // eslint-disable-next-line react/destructuring-assignment
  const hideTitle = context.showTitle === false;

  const update = (patch) => onChange({ ...context, ...patch });

  return (
    <FormErrorHandler errorList={errors} noDivTags>
      <div className="widget-common-edit py-2 text-center">
        <div className="form-group mb-2">
          {/*
            The parent Dashboard strips the "widgets[N]." prefix before
            handing errors to us, so we address the title field by its
            context-relative path.
          */}
          <AltErrorWrapper fieldId="context.title">
            <input
              type="text"
              className="form-control"
              placeholder="Tile Title"
              value={title}
              onChange={(e) => update({ title: e.target.value })}
            />
          </AltErrorWrapper>
        </div>
        <div className="form-group d-flex mb-0">
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label className="form-check-inline mb-0 mr-3">
            <input
              className="mr-2"
              type="radio"
              name={radioName}
              checked={showTitle}
              onChange={() => update({ showTitle: true })}
            />
            Display title
          </label>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label className="form-check-inline mb-0">
            <input
              className="mr-2"
              type="radio"
              name={radioName}
              checked={hideTitle}
              onChange={() => update({ showTitle: false })}
            />
            Hide title
          </label>
        </div>
      </div>
    </FormErrorHandler>
  );
};

CommonWidgetEditFields.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  context: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(PropTypes.shape({
    field: PropTypes.string,
    message: PropTypes.string,
    code: PropTypes.string,
  })),
};

CommonWidgetEditFields.defaultProps = {
  errors: [],
};

export default CommonWidgetEditFields;
